module.exports = __webpack_public_path__ + "static/media/Pham_Ngoc_Bao_Anh.f6b315f1.jpg";